export default {
  fleet_memberships: {
    create: "Member already present or has a pending invite",
  },
};
